import * as QuestionnaireApiModels from '@/typings/questionnaires-api-models';

const isPresenceValid = (value: unknown, requiredFields: string[]): boolean => {
  if (value === null || value === undefined) {
    return false;
  }
  if (typeof value === 'object') {
    return requiredFields.every(field => {
      const fieldValue = (value as Record<string, unknown>)[field];
      return fieldValue !== undefined && fieldValue !== null && fieldValue !== '';
    });
  }
  return !!value;
};

const checkFieldValidity = (field: Pick<QuestionnaireApiModels.FieldTemplate, 'type'>, fieldValue: unknown): boolean => {
  if (field.type === 'name') {
    return isPresenceValid(fieldValue, ['firstName', 'lastName']);
  }

  if (field.type === 'currency') {
    return isPresenceValid(fieldValue, ['amount']);
  }

  if (field.type === 'address-us') {
    return isPresenceValid(fieldValue, ['line1', 'city', 'zip']);
  }

  if (field.type === 'address-international') {
    return isPresenceValid(fieldValue, ['line1', 'city', 'postCode']);
  }

  // For other field types, check if the value is truthy
  return !!fieldValue;
};

export default checkFieldValidity;
